<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import '../assets/common.css';
@import './static/iconfont/iconfont.css';
html{
  font-size: 18px!important;
}
/* #app {
  min-width: 1300px;
} */
</style>
